import React, { useState, useEffect } from "react"
import _ from "lodash"

import RowAddRemove from "components/table/carousel/row-add-remove"
import { MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"
import { Colors } from "styles/app-styles"

type Item_t = object & {
  i: number
}

const InputTypeDetailed = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyRecord = {
    inputtype: "detailed",
    payoutdetail: {
      state: "detailed",
      items: []
    }
  }
  const emptyItem = {
    month: null,
    percent: null
  }

  const [data, setData] = useState<object|null>({...props.rowData})
  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {"month": item.month, "percent": item.percent, i }}), "month") : [{...emptyItem, i:0}])

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'detailed') {
      setData(emptyRecord)
      setItems([{...emptyItem, i: 0}])
    }
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)
    let nextItems = _.cloneDeep(items);
    nextItems = nextItems.map(item => {
      return {month: item.month, percent: item.percent}
    })

    _.set(nextData, "inputtype", "detailed")
    _.set(nextData, "payoutdetail", {
      state: "detailed"
    })
    _.set(nextData, "payoutdetail.items", nextItems)

    if(!_.isArray(field)) {
      nextData[field] = localCache[field] = val
    } else {
      if(nextItems[field[0]][field[1]] === val) return
      nextItems[field[0]][field[1]] = val
      _.set(localCache, "payoutdetail.items", nextItems)
      _.set(nextData, "payoutdetail.items", _.sortBy(nextItems, "month"))
      setItems(nextItems.map((item, i) => { return {month: item.month, percent: item.percent, i}}));
    }
    setData(localCache)

    nextData["mosoffset"] = null

    props.persist(nextData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)
    let nextItems = items.map((item, i) => { return {...item}})

    _.set(nextData, "inputtype", "detailed")
    _.set(nextData, "payoutdetail", {
      state: "detailed"
    })

    setItems(nextItems)
    const strippedItems = nextItems.map(({i, ...rest}) => rest)
    _.set(nextData, "payoutdetail.items", strippedItems)

    props.persist(nextData, props.field, props.rowData)
  }

  let renderItems = _.sortBy(items, 'i')
  const params = {
    data: items,
    persist: updateData
  }

  const item_attrs = (field) => field_attrs('payout', `${props.field}.items`)(field)(props.rowData, props)

  const total_percent = _.reduce(items, (sum, item) => sum + item.percent, 0)

  return (
    <div className="payout-detailed-container">
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div>
              { i === 0 && <label>Month</label> }
              <NumberInput className="automated" attrs={item_attrs} field={[row['i'], 'month']} {...params} />
            </div>
            <div>
              { i === 0 && <label>Percent</label> }
              <NumberInput className="automated" attrs={item_attrs} field={[row['i'], 'percent']} {...params} readPrecision={4} writePrecision={4} persist={updateData} />
            </div>
            <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={renderItems} />
          </MultiRowCarouselState_s>
      ))}
      <div className="total-percent">Total Percent:
        <span style={total_percent === 100 ? {color: Colors.colorSuccess} : {color: Colors.colorDanger}}>
          &nbsp; {total_percent}
        </span>
      </div>
    </div>
  )
}

export default InputTypeDetailed
